import React from 'react';

interface ServiceCardProps {
  icon: string;
  title: string;
  description: string;
  delay?: number;
}

const ServiceCard: React.FC<ServiceCardProps> = ({ icon, title, description, delay = 0 }) => {
  const delayClass = `delay-${delay}`;

  return (
    <div className={`service-card ${delayClass}`}>
      <div className="card-content">
        <div className="icon-container">
          <div className="icon-wrapper">
            <img src={icon} alt="Service Icon" className="icon" />
          </div>
        </div>
        <div className="card-text">
          <p className="card-description">{title}</p>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;
